import { __assign, __rest } from "tslib";
import React, { useState, useRef, useEffect, useContext } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import cn from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import AnimatedHotspot from '@wix/da-ds/pkg/AnimatedHotspot';
import TextTooltipOnHover from '../../Popover/Preset/TextTooltipOnHover';
import { FirstTimeFlag } from '../../redux/firstTimeFlags/constants';
import { useFirstTimeFlag } from '../../redux/firstTimeFlags/hooks';
import TierPromotionCard from '../TierPromotionCard';
import FellaTooltip from './FellaTooltip';
import s from './TierPromotionCardWithFellaTooltip.scss';
/**
 * A TierPromotionCard wrapped in a custom tooltip to be rendered in browse, only for
 * users having a specific FTUE flag on.
 * Depending on the position of the card in the screen, the tooltip will render above or below it.
 * A portal is used to allow the card to pop out and show an overlay covering the rest of the screen.
 */
var TierPromotionCardWithFellaTooltip = function (_a) {
    var isPostsFeedCard = _a.isPostsFeedCard, innerRef = _a.innerRef, props = __rest(_a, ["isPostsFeedCard", "innerRef"]);
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useState(false), showFellaTooltip = _b[0], setShowFellaTooltip = _b[1];
    var _c = useState(null), tooltipCoords = _c[0], setTooltipCoords = _c[1];
    var cardNodeRef = useRef(null);
    var _d = useFirstTimeFlag(FirstTimeFlag.IsBrowseSubscriptionsPromotionNotSeen), dropFlag = _d.dropFlag, hasFTUEFlag = _d.hasFlag;
    // When tooltip is shown/hidden, take care of body scroll locking
    useEffect(function () {
        var cardEl = cardNodeRef.current;
        if (showFellaTooltip) {
            cardEl && disableBodyScroll(cardEl);
        }
        else {
            cardEl && enableBodyScroll(cardEl);
        }
    }, [showFellaTooltip, innerRef]);
    // This handler is called as long as the FTUE flag is still enabled
    var handleHotspotHover = function () {
        var cardEl = cardNodeRef.current;
        if (cardEl) {
            var domRect = cardEl.getBoundingClientRect();
            setTooltipCoords({
                top: domRect.top,
                left: domRect.left,
            });
            setShowFellaTooltip(true);
        }
    };
    var handleFellaTooltipDismiss = function () {
        dropFlag();
        setShowFellaTooltip(false);
    };
    var hotspotClassName = cn(s['hotspot'], isPostsFeedCard && s['posts']);
    var hotspot;
    if (isMobile) {
        hotspot = hasFTUEFlag && (React.createElement(TextTooltipOnHover, { wrapperClassName: s['basic-tooltip'], placement: 'right', tooltipText: t('deviationview.tierCard.mobileTooltipText'), title: t('deviationview.tierCard.mobileTooltipTitle'), listenOnClicks: true, onHide: function () { return dropFlag(); }, renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(AnimatedHotspot, { className: hotspotClassName, ref: ref }));
            } }));
    }
    else {
        hotspot = hasFTUEFlag ? (React.createElement(AnimatedHotspot, { className: hotspotClassName, onMouseOver: handleHotspotHover })) : (React.createElement(TextTooltipOnHover, { wrapperClassName: s['basic-tooltip'], placement: 'right', tooltipText: React.createElement(Trans, { i18nKey: 'deviationview.tierCard.tooltipText' },
                "This content is part of Subscriptions.",
                React.createElement("br", null),
                "Subscribe to unlock"), renderReference: function (_a) {
                var ref = _a.ref;
                return (React.createElement(AnimatedHotspot, { className: hotspotClassName, ref: ref }));
            } }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(TierPromotionCard, __assign({ hotspot: hotspot, innerRef: function (node) {
                cardNodeRef.current = node;
                innerRef && innerRef(node);
            } }, props)),
        showFellaTooltip && tooltipCoords && (React.createElement(FellaTooltip, { top: tooltipCoords.top, left: tooltipCoords.left, forcePlacementRight: isPostsFeedCard, onDismiss: handleFellaTooltipDismiss },
            React.createElement(TierPromotionCard, __assign({}, props))))));
};
TierPromotionCardWithFellaTooltip.displayName =
    'TierPromotionCardWithFellaTooltip';
export default TierPromotionCardWithFellaTooltip;
//# sourceMappingURL=TierPromotionCardWithFellaTooltip.js.map